module.exports = __webpack_public_path__ + "img/4.53524686.png";